import Header from "../components/Header";
import Blog from "../components/blog/Blog.js";

function Home() {
  return (
    <>
      <Header />
      <Blog/>
      {/* home page content later */}
  
    </>
  );
}

export default Home;
